import api from "../global/Api";
import { ENDPOINTS } from "../global/ApiEndpoints";

export const getAllPhcMaterials = async (page, size, searchString) => {
  const response = await api.get(`/${ENDPOINTS.DEAERATOR_PHC_MATERIAL}`, {
    params: {
      page,
      size,
      search: searchString,
    },
  });

  return response.data;
};